import apiService from '@/services/apiService';

const actions = {
  getDownloadBanner({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('download-banner/find-one')
        .then((response) => {
          commit('getDownloadBanner', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postDownloadBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('download-banner/insert-or-update', payload)
        .then((response) => {
          // commit('postAboutUsBanner', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
